import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../../Button/Button';
import { Text } from '../../Text/Text';
import { Dialog } from '../Dialog/Dialog';
import { DialogButtonRow } from '../Dialog/DialogButtonRow';
export const SessionExpiredDialog = ({ title, description, loginButtonText, onLoginClick, }) => {
    const maybeFooter = loginButtonText ? (_jsx(DialogButtonRow, { children: _jsx(Button, { color: 'action', variant: 'dark', onClick: onLoginClick, children: loginButtonText }) })) : null;
    return (_jsx(Dialog, { title: title, footer: maybeFooter, open: true, onClose: onLoginClick, onOutsideClick: onLoginClick, children: _jsx(Text, { children: description }) }));
};
